export default __webpack_public_path__ + "static/artistBox-yae-yugiri-bd6e1c774dce09ccf31dfc659acfea68.png";